/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
'use strict';

const intra_module = angular.module('intra', [
    'ngRoute',
    'ngResource',
    'ngSanitize',
    'ngNotify',
    'ngCookies',
    'ui.bootstrap',
    'ui.select',
    'etna-calendar',
    'monospaced.elastic',
    'intra-templates',
    'angular-toArrayFilter',
    'highcharts-ng',
    'angular-inview',
    'infinite-scroll',
    'codemwnci.markdown-edit-preview',
    'angular.filter',
    'hc.marked',
    'etna-finder',
    'moment-picker'
]);

intra_module.constant('api_url', window.API_URL);
intra_module.constant('hub_api_url', window.HUB_API_URL);
intra_module.constant(
	'hub_web_url',
	window.HUB_WEB_URL ? window.HUB_WEB_URL : window.API_URL.replace('intra-api.', 'hub.')
);
intra_module.constant('achievements_url', window.ACHIEVEMENTS_URL);
intra_module.constant('modules_url', window.MODULES_URL);
intra_module.constant('tickets_url', window.TICKETS_URL);
intra_module.constant('gsa_url', window.GSA_URL);
intra_module.constant('profmanager_url', window.PROFMANAGER_URL);
intra_module.constant('intraprof_web_url', window.INTRAPROF_WEB_URL);
intra_module.constant('intraprof_api_url', window.INTRAPROF_API_URL);
intra_module.constant('language_url', window.LANGUAGE_URL);
intra_module.constant('is_production', window.IS_PRODUCTION);

intra_module.config(function(
    $routeProvider,
    $httpProvider,
    $sceDelegateProvider,
    $uibTooltipProvider,
    $cookiesProvider,
    uiSelectConfig,
	featuresProvider,
    identityProvider,
    markedProvider,
    momentPickerProvider
) {
    // on envoie le cookie sur toute nos requetes http par défaut
    $httpProvider.defaults.withCredentials = true;

    // on whitelist les différents domaines etna
    const whiteList = $sceDelegateProvider.resourceUrlWhitelist();
    whiteList.push('.*\.etna\.dev');
    whiteList.push('.*\.etna-alternance\.net');

    // append au body toutes les tooltips
    // (plutôt que contextuellement là où elles sont)
    $uibTooltipProvider.options({ appendToBody: true });

    // utilisation du theme bootstrap pour le module uiSelect
    uiSelectConfig.theme = 'bootstrap';

    markedProvider.setOptions({
        sanitize: true});

    markedProvider.setRenderer({
        listitem(text, level) {
            if (!/^\s*\[[x ]\]\s*/.test(text)) { return `<li>${text}</li>`; }
            text = text
                .replace(/^\s*\[x\]\s*/, '<input type="checkbox" checked disabled/> ')
                .replace(/^\s*\[ \]\s*/, '<input type="checkbox" disabled/> ');
            return `<li style=\"list-style: none\">${text}</li>`;
        },

        table(header, body) {
            return `<table class=\"table table-striped table-bordered\"> \
<thead> \
${header} \
</thead> \
<tbody> \
${body} \
</tbody> \
</table>`;
        },
        link(href, title, text) {
            const regex = /(\.mp4|\.m4v|\.mov|\.ogg)(?:\?.*)?$/;
            const video = `<video controls preload='none' style='width: 100%'><source src='${href}'></source></video>`;

            const title_attr = (title != null) ? `title='${title}'` : '';
            const blank_link = `<a href='${href}' ${title_attr} target='_blank'>${text}</a>`;

            return blank_link + (href.match(regex) ? video : '');
        },

        image(src, desc, alt) {
            const injector = angular.injector(['ngCookies']);
            // 'Safe for Work'
            const $cookies = injector.get('$cookies');
            if (('true' === $cookies.get('sfw')) || (true === $cookies.get('sfw'))) {
                return  `<div class="alert alert-info"> \
<strong>Safe For Work!</strong> Les images n\'apparaitront pas sur votre mur dans ce mode. \
</div>`;
            } else {
                return `<img src='${src}' alt='${alt}'/>`;
            }
        }
    });

    // Black Magic, touch this and i kill you in your bed
    // ça remplace 'MonResolve' par ['MonResolve', (a) -> a() ]
    const getResolvers = function(dict) {
        for (let key in dict) {
            const value = dict[key];
            dict[key] = [ value, a => a() ];
        }
        return dict;
    };

    const customRouteProvider = angular.extend({ }, $routeProvider, {
        when(path, route) {
            route.resolve = (route.resolve != null) ? route.resolve : { };
            angular.extend(route.resolve, {
                ensureAuth: ['identity', identity => identity.$promise
                ]
            });
            $routeProvider.when(path, route);
            return this;
        }
    });

	// We're in the module config() function, which is too early to depend directly on the
	// features service. Instead, we have to depend on the Provider and ask it to instanciate
	// the service for us. See: https://stackoverflow.com/questions/22682753
	const feature_no_log_schedules_enabled = featuresProvider.$get().no_log_schedules_enabled;
	
    customRouteProvider
        .when('/', {
            controller:        'IdentityCtrl',
            template:          '<div></div>'
        }).when('/404',
            {templateUrl:       'partials/404.html'})
        .when('/403',
            {templateUrl:       'partials/403.html'})
        .when('/error', {
            templateUrl:       'partials/error.html',
            controller:        'ErrorCtrl'
		})
		.when('/fdt', {
			templateUrl:        ( feature_no_log_schedules_enabled ? 'partials/fdt2.html' : 'partials/fdt.html' ),
			controller:         ( feature_no_log_schedules_enabled ? 'FdtCtrl2' : 'FdtCtrl' ),
			resolve:            getResolvers({
				currentModules:    'ModulesResolve',
				terms:             'CurrentTermsResolve'
			})
		})
        .when('/features', {
            templateUrl:        'partials/features.html',
            controller:         'FeaturesCtrl',
        })
		.when('/user/:login', {
            controller:        'UserProfileCtrl',
            templateUrl:       'partials/user_profile.html',
            resolve:           getResolvers({ user: 'UserResolve' })
        })
        .when('/declarations', {
            controller:        'DeclarationsCtrl',
            templateUrl:       'partials/declarations.html'
        }).when('/promo/archives', {
            controller:        'PromoArchivesCtrl',
            templateUrl:       'partials/archives.html',
            reloadOnSearch:    false,
            resolve:           getResolvers({ auth: 'ADMAuthResolve' })
        })
        .when('/promo/:name', {
            controller:        'WallPromoCtrl',
            templateUrl:       'partials/wall_promo.html',
            resolve:           getResolvers({ term: 'TermResolve' })
        })
        .when('/user/:login/achievements', {
            templateUrl:       'partials/user_achievement.html',
            controller:        'UserAchievementCtrl',
            resolve:           getResolvers({ user: 'UserResolve', achievements: 'UserAchievementResolve' })
        })
		.when('/user/:login/elearning', {
            templateUrl:   'partials/user_elearning.html',
            controller:    'UserElearningCtrl',
            resolve:        getResolvers({
                user:           'UserResolve',
                terms:          'CurrentTermsResolve',
                modules:        'ModulesResolve',
                restriction:    'RestrictionElearningResolve'
            }),
            reloadOnSearch: false
        }).when('/prof/:login/elearning', {
            template: '',
            controller: 'RedirectProfElearningCtrl'
        }).when('/user/:login/elearning/:id', {
            redirectTo(current, path, search) {
                let redirect_url =  `/user/${current.login}/elearning?id=${current.id}`;
                if (search.term_id != null) {
                    redirect_url += `&term_id=${search.term_id}`;
                }
                return redirect_url;
            }
        }).when('/student/:login/elearning',
            {redirectTo(current) { return `/user/${current.login}/elearning`; }})
        .when('/student/:login/elearning/:id',
            {redirectTo(current) { return `/user/${current.login}/elearning?id=${current.id}`; }})
        .when('/user/:login/grades', {
            templateUrl:       'partials/user_grades.html',
            controller:        'UserGradesCtrl',
            resolve:           getResolvers({ user: 'UserResolve', sessions: 'SessionsResolve', terms: 'TermsResolve' }),
            reloadOnSearch:    false
        }).when('/user/:login/planning', {
            templateUrl:       'partials/planning.html',
            controller:        'PlanningCtrl',
            resolve:           getResolvers({ user: 'UserResolve' }),
            reloadOnSearch:    false
        }).when('/sessions/:session_id/cours/:activity_id', {
            templateUrl: 'partials/course.html',
            controller:  'CourseCtrl',
            resolve:
                getResolvers({
                    courses: 'CoursesResolve',
                    course:  'ProjectResolve',
                    module:  'ModuleResolve'
                }),
            reloadOnSearch:    false
        }).when('/tickets', {
            templateUrl:       'partials/tickets.html',
            controller:        'TicketCtrl',
            resolve:           getResolvers({ tickets: 'TicketsResolve' }),
            reloadOnSearch:    false
        }).when('/tickets/new', {
            templateUrl:       'partials/ticketsnew.html',
            controller:        'NewTicketCtrl',
            reloadOnSearch:    false
        }).when('/tickets/:id', {
            templateUrl:       'partials/ticketsdetails.html',
            controller:        'DetailsTicketCtrl',
            resolve:           getResolvers({ ticket: 'TicketResolve' }),
            reloadOnSearch:    false
        }).when('/search/:query', {
            templateUrl:       'partials/search.html',
            controller:        'SearchCtrl'
        }).when('/sessions/:session_id/:activity_type/:activity_id', {
            templateUrl:       'partials/project.html',
            controller:        'ProjectCtrl',
            resolve:           getResolvers({ project: 'ProjectResolve' }),
            reloadOnSearch:    true,
        }).when('/sessions/:session_id/:activity_type/:activity_id/stage/:stage_name', {
            redirectTo(curr) {
                return `/sessions/${curr.session_id}/${curr.activity_type}/${curr.activity_id}?stage=${curr.stage_name}`;
            }
        }).when('/files', {
            templateUrl:       'partials/files.html',
            controller:        'PublicFilesCtrl'
        }).when('/filesbank', {
            templateUrl:       'partials/files_bank.html',
            controller:        'PublicFilesBankCtrl'
        }).when('/trombi', {
            templateUrl:       'partials/trombi.html',
            controller:        'TrombiCtrl',
            reloadOnSearch:    false
        }).when('/informations', {
            templateUrl:       'partials/informations.html',
            controller:        'ArchivedInfosCtrl'
        }).when('/wall/:wall_name', {
            templateUrl:       'partials/other_wall.html',
            controller:        'OtherWallCtrl',
            resolve:            getResolvers({ wall: 'StaticWallResolver' })
        }).when('/personal-info-sheet', {
            templateUrl:       'partials/personal_info_sheet.html',
            controller:        'PersonalInfoSheetCtrl'
        }).when('/sign/sheet/:sheet_id', {
			templateUrl: 'directives/pending-signatures-alertbox/page.html',
			controller: 'SheetSignatureCtrl',
			resolve: {
				sheet_id($route) { return $route.current.params.sheet_id; },
			},
		})
        .otherwise({
            redirectTo: '/'});

    return momentPickerProvider.options({
        locale:        'fr',
        today:         true,
        keyboard:      false,
        setOnSelect:   true,
        leftArrow:     '&larr;',
        rightArrow:    '&rarr;',
        yearsFormat:   'YYYY',
        monthsFormat:  'MMM',
        daysFormat:    'DD',
        minDate:       moment().format('YYYY-MM-DD'),
        minutesFormat: 'mm',
        minutesStep:   5,
        secondsStep:   1
    });
});

// Pour ceux qui veulent tenter de comprendre le resolve, et je ne les encourage pas spécialement
// https://groups.google.com/forum/?fromgroups#!topic/angular/QtO8QoxSjYw
